import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="fixed w-full z-50 bg-dark/90 backdrop-blur-md border-b border-white/10" data-id="element-230" data-mp="jhz8x3l1frbv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231" data-mp="x9dv1ja8s8n5">
        <div className="flex justify-between items-center h-24" data-id="element-232" data-mp="saaqdzy6c4fp">
          <div className="flex-shrink-0 flex items-center" data-id="element-233" data-mp="sd59no5gbj7j">
            <img src="https://cdn.magicpatterns.com/uploads/evyospU31vfdfaKZswB6gc/Photoroom_20260524_142746.png" alt="AS Elite Contractor Logo" className="h-16 md:h-20 w-auto object-contain" data-id="element-234" data-mp="4lztt8zigqx8" />
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-235" data-mp="9jrwmy1p1xg7">
            <a href="#servicios" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-236" data-mp="9me0amlgrst5">
              Servicios
            </a>
            <a href="#portafolio" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-237" data-mp="1l1kjzxdn1dcj">
              Portafolio
            </a>
            <a href="#nosotros" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-238" data-mp="epnfprhbpl4q">
              Nosotros
            </a>
            <a href="#resenas" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-239" data-mp="okyto7kwqobf">
              Reseñas
            </a>
            <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="bg-gold text-dark px-6 py-2.5 rounded-full font-bold text-sm hover:bg-gold-400 transition-all transform hover:scale-105" data-id="element-240" data-mp="3s2yy5cr98bka">
              EMPIEZA HOY →
            </a>
          </div>

          <div className="md:hidden flex items-center" data-id="element-241" data-mp="39b619792e67a">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-300 hover:text-white" data-id="element-242" data-mp="399mmjl32437m">
              {isOpen ? <X className="h-6 w-6" data-id="element-243" data-mp="2wbnfa2itnbr2" /> : <Menu className="h-6 w-6" data-id="element-244" data-mp="3b1mb3ymwmb3d" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-dark-100 border-b border-white/10" data-id="element-245" data-mp="364ce9xx6qx5i">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-246" data-mp="2icxgmigct40l">
            <a href="#servicios" className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-247" data-mp="2de44atcszj20">
              Servicios
            </a>
            <a href="#portafolio" className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-248" data-mp="2nbrz1jaesqk6">
              Portafolio
            </a>
            <a href="#nosotros" className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-249" data-mp="2l9n6x0jttmj">
              Nosotros
            </a>
            <a href="#resenas" className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-250" data-mp="a6vamsbozijd">
              Reseñas
            </a>
            <a href="https://wa.me/447311754270?text=WEBSITE" className="block px-3 py-2 text-gold font-bold" data-id="element-251" data-mp="15x6ma197b0s">
              EMPIEZA HOY →
            </a>
          </div>
        </div>}
    </nav>;
}